export default "__VITE_ASSET__gcm7E3J$__"